// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-tripStatusApiTab-module__tab--nzAP7 {
  padding: 10px 0;
}

.src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessage--IPSHW {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 80px;
  min-height: 300px;
  color: #6b6b6b;
  text-align: center;
}

.src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessageTitle--e5dZi {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}

.src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessageSubtitle--zqxlZ {
  font-size: 16px;
  color: #9b9b9b;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/tripStatusApiTab.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".tab {\n  padding: 10px 0;\n}\n\n.stateMessage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 80px;\n  min-height: 300px;\n  color: #6b6b6b;\n  text-align: center;\n}\n\n.stateMessageTitle {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.stateMessageSubtitle {\n  font-size: 16px;\n  color: #9b9b9b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `src-js-pages-usageReportingContainer-tripStatusApiTab-module__tab--nzAP7`,
	"stateMessage": `src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessage--IPSHW`,
	"stateMessageTitle": `src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessageTitle--e5dZi`,
	"stateMessageSubtitle": `src-js-pages-usageReportingContainer-tripStatusApiTab-module__stateMessageSubtitle--zqxlZ`
};
export default ___CSS_LOADER_EXPORT___;
